import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300 } = GW_SERVICES_PREFIXES;

/* Получение справок для вкладок списком */
export const GetTabsList = () => API.get(`/${C300}/tabs/list/`);

/* Получение справки для конкретной вкладки по id */
export const GetTab = (id: string) => API.get(`/${C300}/tabs/retrieve/`, id);

/* Изменение справки (принимает tab(id), а также help(string) и description(string) */
export const EditTab = (params: IParams) =>
  API.gatewayPatch(`/${C300}/tabs/edit/`, undefined, params);

/* Получение ссылок на справку "Помощь по разделу" */
export const GetTabLinks = () => API.get(`/${C300}/models/help_links/`);

/* Изменение ссылки на справку "Помощь по разделу" */
// передавать id самого объекта коллекции RequestTabDescriptionForCreate
export const PatchTabLink = (id: string, params: IParams) =>
  API.gatewayPatch(`/${C300}/models/help_links/`, id, params);
